import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import af from './locales/af.json';

/**
 * Frontend i18n instance.
 *
 * Languages: English ('en', default) and Afrikaans ('af').
 * Language preference is persisted per-user in localStorage under the key
 * returned by getUserLangKey(userId). This means each user's preference is
 * independent, and the login screen always renders in English (the default).
 */
i18next
  .use(initReactI18next)
  .init({
    lng: 'en',
    fallbackLng: 'en',
    supportedLngs: ['en', 'af'],
    resources: {
      en: { translation: en },
      af: { translation: af },
    },
    interpolation: {
      escapeValue: false,
    },
  });

/** Returns the localStorage key used to persist a specific user's language. */
export const getUserLangKey = (userId: string) => `i18nextLng_${userId}`;

export default i18next;
